import { createContext } from "react";
import { UserDto } from "../api-clients/api";

export interface AuthState<T> {
    isAuthenticated: T;
    isAuthenticating: T;
    user: UserDto | null | undefined;
    login: Function;
}

export const AuthContext = createContext<AuthState<true | false>>({
    isAuthenticated: false,
    isAuthenticating: true,
    user: undefined,
    login: () => {}
});